/**
 * Утилита для надёжного запуска скрипта.
 * Привязывается к DOMContentLoaded, но учитывает вероятность "подздней подписки",
 * чтобы выполнить скрипт даже если он был загружен после готовности документа.
 */
export function onDomReady(init: () => void) {
    const run = () => init();

    if (document.readyState === 'loading') {
        // Ожидаем полной загрузки документа
        document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
        // Документ уже загружен/интерактивен — запускаемся сразу
        queueMicrotask(run);
    }
}
